import styled from '../../../../../../theme/theme';

export const VestingRowContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.space['12'],
  padding: `${theme.space['8']}px ${theme.space['24']}px`,
  borderBottom: `1px solid ${theme.colors.neutral['200']}`,
  pageBreakInside: 'avoid',

  '&:last-child': {
    borderBottom: 'none',
  },
}));
